import { render, staticRenderFns } from "./ActivityWidget.vue?vue&type=template&id=0b0fd117&"
import script from "./ActivityWidget.vue?vue&type=script&lang=js&"
export * from "./ActivityWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports